import { systemGroupType } from "../../../../providers/dataPlatformReportTypes";
import { ClientGender, isOppositeGenderSystem } from "../../hooks/useClientGender";

/**
 * How many system scores are waiting for the affiliate to approve or hide.
 *
 * Shared by everything that reacts to that state — the pending-approvals
 * banner and the post-save prompt after new biomarkers land — so they can
 * never disagree about what "pending" means: neither hidden (2) nor approved
 * (4), ignoring the sexual-wellness system of the gender the client isn't.
 */
export const countPendingSystems = (
  systems: systemGroupType[] | undefined,
  gender: ClientGender
): number =>
  (systems || []).filter((sys: any) => {
    if (isOppositeGenderSystem(sys.system, gender)) return false;
    return sys.approval !== 2 && sys.approval !== 4;
  }).length;
